import { render, staticRenderFns } from "./ConsentWithdrawals.vue?vue&type=template&id=98aaf546"
import script from "./ConsentWithdrawals.vue?vue&type=script&lang=js"
export * from "./ConsentWithdrawals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports